/** Profile fields allocated by the employer — workers must not PATCH these. */
export const PROFILE_WORKER_READ_ONLY_PATCH_KEYS = [
  'credits',
  'available_credits',
  'credit_balance',
  'credits_balance',
  'remaining_credits',
  'employer_credits',
  'employer_credit_balance',
  'credits_per_employee',
] as const;

export function isWorkerReadOnlyProfileFieldKey(key: string): boolean {
  const normalized = key.trim().toLowerCase().replace(/\s+/g, '_');
  return (PROFILE_WORKER_READ_ONLY_PATCH_KEYS as readonly string[]).includes(normalized);
}

export function isWorkerReadOnlyProfileFieldPath(path: readonly string[]): boolean {
  if (path.length !== 1) {
    return false;
  }
  return isWorkerReadOnlyProfileFieldKey(path[0] ?? '');
}

export function stripWorkerReadOnlyProfilePatchFields(
  body: Record<string, unknown>,
): Record<string, unknown> {
  const out = { ...body };
  for (const key of Object.keys(out)) {
    if (isWorkerReadOnlyProfileFieldKey(key)) {
      delete out[key];
    }
  }
  return out;
}
